// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"59":"5cd95cc8","832":"b536224c"}[chunkId] || chunkId) + "." + {"59":"e681b9ffca6a379a","152":"4e00f1063c468a2a","160":"d06c2adaa645de19","173":"d3e537ca2caeeb65","196":"dedb1931a56c359d","357":"756737ade3fc7dfd","582":"685998d163f77e56","832":"a09a1b1ac53e1e85"}[chunkId] + ".js";
};